import { useState } from 'react'
import { getCookieByName, setCookie } from '@helpers/session'
import { replaceLocale } from '@helpers/env'
import { COOKIE_EXPIRE_1_MONTH } from '@consts/index'
import { ShopLocale } from 'types/locales'
import { ReactComponent as UKFlagIcon } from '@svgs/uk-flag.svg'
import { ReactComponent as EUFlagIcon } from '@svgs/eu-flag.svg'
import { ReactComponent as USFlagIcon } from '@svgs/us-flag.svg'
import Modal from '@components/ui/Modal'
import styles from './styles.module.scss'
import { analytics } from '@helpers/analytics'

export const LINK_TRACKING_DELAY = 300

const COUNTRIES = [
  {
    image: UKFlagIcon,
    locale: 'gb',
    text: 'UK'
  },
  {
    image: EUFlagIcon,
    locale: 'eu',
    text: 'EU'
  },
  {
    image: USFlagIcon,
    locale: 'us',
    text: 'US'
  }
] as const

type CountryModalProps = {
  shopLocale: ShopLocale
}

function CountryModal({ shopLocale }: CountryModalProps) {
  const [isOpen, setIsOpen] = useState(true)

  const geoRegionCode = getCookieByName('geo_region_code')

  const handleCountrySelection = (
    ev?: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    countryLocale?: ShopLocale
  ) => {
    ev?.preventDefault()
    const { currentTarget } = ev || {}

    const thChosenCookieValue = countryLocale || shopLocale

    analytics('Geo Modal Prompt', {
      action: countryLocale ? `${currentTarget?.title} flag` : 'close',
      th_chosen: thChosenCookieValue,
      geo_region_code: geoRegionCode
    })

    setCookie('th_chosen', thChosenCookieValue, COOKIE_EXPIRE_1_MONTH, true)

    if (currentTarget && countryLocale !== shopLocale) {
      setTimeout(() => {
        window.location.assign(currentTarget.href)
      }, LINK_TRACKING_DELAY)
    } else {
      setIsOpen(false)
    }
  }

  return (
    <Modal openedModal={isOpen} onClose={() => handleCountrySelection()}>
      <div className={styles.CountryModal}>
        <h2>Where are we shipping to?</h2>
        <p>
          Purchasing from your country's website is the best way to get the
          perfect fit
        </p>
        <div className={styles.linksWrapper}>
          {COUNTRIES.map(({ image: Image, locale, text }) => (
            <a
              className={styles.link}
              href={replaceLocale(
                locale?.toUpperCase() === 'GB'
                  ? ''
                  : `/${locale?.toLowerCase()}`
              )}
              onClick={ev =>
                handleCountrySelection(
                  ev,
                  locale.toUpperCase() as Uppercase<
                    (typeof COUNTRIES)[number]['locale']
                  >
                )
              }
              key={locale}
              title={text}
              hrefLang={locale}
              rel="alternate"
              aria-label={`Switch to our ${text} store`}
            >
              <Image width="106" height="80" />
              {text}
            </a>
          ))}
        </div>
        <p className={styles.footerMessage}>
          Somewhere else? Head to the UK store, and select your country at
          checkout.
        </p>
      </div>
    </Modal>
  )
}

export default CountryModal
